import Divider from '../../Divider';
import FControlLabel from '../../shared/Forms/FControlLabel';
import { IEvaluacion } from '../constants';
import { FormControl, RadioGroup } from '@mui/material';


interface Props {
  dataEvaluacion: IEvaluacion;
  handleChange(type: string, value: string | number): void;
}

const CantidadComidas = ({ dataEvaluacion, handleChange } : Props) => {

  return (
    <div>
      <div className='text-center'>
        <h2 className="title font-bold mb-2">
          ¿Cuántas comidas consumirás al día en este nuevo mes?
        </h2>
        <p className="text-slate-500">Seleccione la cantidad de comidas que consumirás al día</p>
        <Divider type="option" />
      </div>
      <div className="row">
        <div className="col-12" style={{ textAlign: 'left' }}>
          <FormControl>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              name="radio-buttons-group"
              value={dataEvaluacion.cantidadComidas}
              onChange={(e) => {
                handleChange('cantidadComidas', e.target.value);
              }}
            >
              <FControlLabel value={3} size='1.15rem' label="3 veces al día" fontWeight={500} />
              <FControlLabel value={4} size='1.15rem' label="4 veces al día" fontWeight={500} />
              <FControlLabel value={5} size='1.15rem' label="5 veces al día" fontWeight={500} />
            </RadioGroup>
          </FormControl>
        </div>
      </div>
    </div>
  )
}

export default CantidadComidas